"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var isUndefined_1 = tslib_1.__importDefault(require("./isUndefined"));
function when(predicate, callback, a) {
    if ((0, isUndefined_1.default)(a)) {
        return function (b) { return when(predicate, callback, b); };
    }
    if (predicate(a)) {
        return callback(a);
    }
    return a;
}
exports.default = when;
//# sourceMappingURL=when.js.map